import React from 'react';
import { ChallengesContext, RewardsHubContext, InfoRewardsContext, } from '../../../../contexts';
import { HasDataStateRewards, ErrorStateBoth, LoadingStateRewards, } from './RewardCardStates';
export var Rewards = function (_a) {
    var isMobile = _a.isMobile;
    var _b = React.useContext(InfoRewardsContext), isLoadingRewards = _b.isLoading, hasRewardsError = _b.hasError, getPerksInfoRewardsData = _b.getPerksInfoRewardsData, rewardList = _b.rewardList;
    var _c = React.useContext(ChallengesContext), isChallengeLoading = _c.isChallengeLoading, getChallengesInfo = _c.getChallengesInfo, hasChallengeError = _c.hasChallengeError;
    var isPageLoaded = React.useContext(RewardsHubContext).isPageLoaded;
    React.useEffect(function () {
        var apiController = new AbortController();
        if (isPageLoaded && isChallengeLoading) {
            getChallengesInfo({ signal: apiController.signal });
        }
        return function () {
            apiController.abort();
        };
    }, [isChallengeLoading]);
    React.useEffect(function () {
        var apiController = new AbortController();
        if (isPageLoaded && isLoadingRewards) {
            getPerksInfoRewardsData({ signal: apiController.signal });
        }
        return function () {
            apiController.abort();
        };
    }, [isLoadingRewards]);
    if (isChallengeLoading || isLoadingRewards)
        return React.createElement(LoadingStateRewards, null);
    if (hasChallengeError && hasRewardsError)
        return React.createElement(ErrorStateBoth, null);
    return React.createElement(HasDataStateRewards, { rewardList: rewardList });
};
